/* ============================================================
   DAVIE LAKE VIEW — Lógica del formulario de captura
   - Preselección de modelo · Selector de país (default US)
   - Calificación: SOLO los leads calificados disparan el evento Lead (Pixel + CAPI)
   - Guarda en Shopify (email a Andrew) + redirige a WhatsApp
   ============================================================ */
(function () {
  'use strict';

  var form = document.getElementById('davie-contact-form');
  var selectedModelValue = null; // precio del modelo elegido en una tarjeta (para el value de Meta)

  /* ---- Preselección de modelo desde las tarjetas ---- */
  document.querySelectorAll('.davie-model-select').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var model = btn.getAttribute('data-model') || '';
      var select = document.getElementById('davie-model');
      if (select && model) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].text.indexOf(model) !== -1) { select.selectedIndex = i; break; }
        }
      }
      // Autoselecciona el rango de presupuesto que corresponde al modelo
      var budget = btn.getAttribute('data-budget') || '';
      var budgetSel = document.getElementById('davie-budget');
      if (budgetSel && budget) budgetSel.value = budget;
      // Guarda el precio del modelo para el evento Lead (sigue al precio editable de la sección)
      var dv = parseInt(btn.getAttribute('data-value'), 10);
      selectedModelValue = isNaN(dv) || dv <= 0 ? null : dv;
      e.preventDefault();
      var target = document.getElementById('davie-lead-form');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var name = document.getElementById('davie-name');
      if (name) setTimeout(function () { name.focus({ preventScroll: true }); }, 600);
    });
  });

  /* ============================================================
     Selector de país (código telefónico) — default Estados Unidos
     ============================================================ */
  var COUNTRIES = [
    { n: 'Estados Unidos', d: '1', f: '🇺🇸' },
    { n: 'Colombia', d: '57', f: '🇨🇴' },
    { n: 'México', d: '52', f: '🇲🇽' },
    { n: 'Venezuela', d: '58', f: '🇻🇪' },
    { n: 'Argentina', d: '54', f: '🇦🇷' },
    { n: 'Perú', d: '51', f: '🇵🇪' },
    { n: 'Ecuador', d: '593', f: '🇪🇨' },
    { n: 'Chile', d: '56', f: '🇨🇱' },
    { n: 'Rep. Dominicana', d: '1', f: '🇩🇴' },
    { n: 'Puerto Rico', d: '1', f: '🇵🇷' },
    { n: 'Panamá', d: '507', f: '🇵🇦' },
    { n: 'Costa Rica', d: '506', f: '🇨🇷' },
    { n: 'Guatemala', d: '502', f: '🇬🇹' },
    { n: 'Honduras', d: '504', f: '🇭🇳' },
    { n: 'El Salvador', d: '503', f: '🇸🇻' },
    { n: 'Nicaragua', d: '505', f: '🇳🇮' },
    { n: 'Bolivia', d: '591', f: '🇧🇴' },
    { n: 'Paraguay', d: '595', f: '🇵🇾' },
    { n: 'Uruguay', d: '598', f: '🇺🇾' },
    { n: 'Brasil', d: '55', f: '🇧🇷' },
    { n: 'España', d: '34', f: '🇪🇸' },
    { n: 'Canadá', d: '1', f: '🇨🇦' }
  ];
  var ccBtn = document.getElementById('davie-cc-btn');
  var ccList = document.getElementById('davie-cc-list');
  var ccFlag = document.getElementById('davie-cc-flag');
  var ccDial = document.getElementById('davie-cc-dial');
  var currentDial = '1';

  if (ccBtn && ccList) {
    COUNTRIES.forEach(function (c, idx) {
      var li = document.createElement('li');
      li.className = 'davie-phone__opt';
      li.setAttribute('role', 'option');
      li.dataset.dial = c.d;
      li.dataset.flag = c.f;
      li.innerHTML = '<span>' + c.f + '</span><span class="davie-phone__optn">' + c.n + '</span><span class="davie-phone__optd">+' + c.d + '</span>';
      li.addEventListener('click', function () {
        currentDial = c.d; ccFlag.textContent = c.f; ccDial.textContent = '+' + c.d;
        closeList();
        document.getElementById('davie-phone').focus();
      });
      ccList.appendChild(li);
    });
    function openList() { ccList.hidden = false; ccBtn.setAttribute('aria-expanded', 'true'); }
    function closeList() { ccList.hidden = true; ccBtn.setAttribute('aria-expanded', 'false'); }
    ccBtn.addEventListener('click', function (e) { e.stopPropagation(); if (ccList.hidden) openList(); else closeList(); });
    document.addEventListener('click', function (e) { if (!ccList.hidden && !ccList.contains(e.target) && e.target !== ccBtn) closeList(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeList(); });
  }

  if (!form) return;

  /* ---- helpers ---- */
  function val(id) { var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; }
  function digits(s) { return (s || '').replace(/\D/g, ''); }
  function getCookie(name) { var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'); return m ? m.pop() : ''; }
  function fullPhone() { return '+' + currentDial + ' ' + val('davie-phone'); }
  function phoneE164() { return '+' + currentDial + digits(val('davie-phone')); }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'davie-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  /* ---- CALIFICACIÓN: el filtro que decide si Meta lo toma como Lead ---- */
  function validEmail() { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('davie-email')); }
  function validPhone() { return digits(val('davie-phone')).length >= 7; }
  // Filtros de negocio (los 2 que importan):
  function qualTime() { var t = val('davie-time'); return t === '0-3 meses' || t === '3-6 meses'; } // solo ≤6 meses
  function qualBudget() { return val('davie-budget') !== 'presupuesto-bajo'; } // "más bajo" descalifica
  function isQualified() { return validEmail() && validPhone() && qualTime() && qualBudget(); }

  // Valor (precio del modelo) para el parámetro "value" del evento Lead → ROAS en Meta
  var MODEL_VALUES = {
    'Model 1-B': 724000, 'Model 2-G': 729000, 'Model 3-ST': 757690, 'Model 4-W': 768490,
    'Model 5-M': 916000, 'Model 6-R': 961990, 'Model 7-PV': 1056390
  };
  function leadValue() {
    if (selectedModelValue) return selectedModelValue; // precio real del modelo elegido en la tarjeta
    var m = val('davie-model');
    for (var key in MODEL_VALUES) { if (m.indexOf(key) !== -1) return MODEL_VALUES[key]; }
    return 800000; // valor representativo si eligió "Aún no lo sé"
  }

  function buildBody() {
    return [
      'Nuevo lead — Landing Davie Lake View',
      'Nombre: ' + val('davie-name'),
      'Email: ' + val('davie-email'),
      'Teléfono: ' + fullPhone(),
      'Modelo de interés: ' + val('davie-model'),
      'Compra estimada: ' + val('davie-time'),
      'Forma de pago: ' + val('davie-pay'),
      'Presupuesto: ' + val('davie-budget'),
      'Contacto preferido: ' + contactMethod(),
      'Calificación: ' + (isQualified() ? 'CALIFICADO' : 'NO CALIFICADO')
    ].join('\n');
  }

  function labelOf(id) {
    var el = document.getElementById(id);
    if (!el) return '';
    if (el.options && el.selectedIndex >= 0) return el.options[el.selectedIndex].text;
    return (el.value || '').trim();
  }

  function contactMethod() {
    var el = document.querySelector('input[name="contact[Contacto preferido]"]:checked');
    return el ? el.value : 'WhatsApp';
  }
  function contactMessage() {
    var tpl = val('davie-wa-msg') ||
      'Hola Andrew, soy {nombre}. Me registré en la página de Davie Lake View y quisiera recibir precios y disponibilidad.';
    var greeting = tpl.replace('{nombre}', val('davie-name'));
    return greeting +
      '\n\nEstas son mis respuestas:' +
      '\n• Modelo de interés: ' + labelOf('davie-model') +
      '\n• Cuándo pienso comprar: ' + labelOf('davie-time') +
      '\n• Forma de pago: ' + labelOf('davie-pay') +
      '\n• Presupuesto: ' + labelOf('davie-budget');
  }
  function whatsappUrl() {
    var wa = digits(val('davie-wa')) || '17864428485';
    return 'https://wa.me/' + wa + '?text=' + encodeURIComponent(contactMessage());
  }
  function smsUrl() {
    var num = digits(val('davie-wa')) || '17864428485';
    // "?&body=" es el formato compatible con iOS y Android
    return 'sms:+' + num + '?&body=' + encodeURIComponent(contactMessage());
  }

  /* ---- Envía el lead: Pixel+Meta SOLO si califica; Worker (email+Sheet) SIEMPRE ---- */
  function sendLead(qualified, eventId) {
    var leadData = {
      content_name: 'Davie Lake View',
      content_category: 'Real Estate Lead',
      currency: 'USD',
      value: leadValue()
    };
    // Pixel del navegador SOLO si califica (mismo eventID para deduplicar con la CAPI)
    if (qualified) {
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead', leadData, { eventID: eventId });
        }
      } catch (err) {}
    }
    // Worker: SIEMPRE — dispara el email a Andrew + guarda en Sheet; a Meta solo si califica
    var capiUrl = val('davie-capi');
    if (capiUrl) {
      var payload = {
        event_id: eventId,
        event_name: 'Lead',
        qualified: qualified,
        event_source_url: window.location.href,
        name: val('davie-name'),
        email: val('davie-email'),
        phone: fullPhone(),
        model: labelOf('davie-model'),
        time: labelOf('davie-time'),
        pay: labelOf('davie-pay'),
        budget: labelOf('davie-budget'),
        contact_pref: contactMethod(),
        fbp: getCookie('_fbp'),
        fbc: getCookie('_fbc'),
        custom: leadData
      };
      try {
        fetch(capiUrl, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(function () {});
      } catch (e) {}
    }
  }

  function setSuccessText(title, text) {
    var s = document.getElementById('davie-success');
    if (!s) return;
    var h = s.querySelector('h3'); var p = s.querySelector('p');
    if (h && title) h.textContent = title;
    if (p && text) p.textContent = text;
  }
  function showSuccess(targetId) {
    var s = document.getElementById(targetId || 'davie-success');
    var fields = form.querySelector('.davie-form-fields');
    if (fields) fields.style.display = 'none';
    // Muestra SOLO el bloque destino; oculta el resto (evita duplicar el mensaje)
    var blocks = form.querySelectorAll('.davie-form-success');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i] === s) continue;
      blocks[i].style.display = 'none';
      blocks[i].classList.remove('is-visible');
    }
    if (s) { s.style.display = ''; s.classList.add('is-visible'); }
  }

  /* ---- Opción "Llamada": copiar el número de Andrew al portapapeles ---- */
  (function initCall() {
    function copyText(text, onDone) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onDone, function () {});
        return;
      }
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); onDone(); } catch (e) {}
      document.body.removeChild(ta);
    }
    var copyBtn = document.getElementById('davie-call-copybtn');
    if (copyBtn) {
      var orig = copyBtn.textContent;
      copyBtn.addEventListener('click', function () {
        copyText(copyBtn.getAttribute('data-num') || '', function () {
          copyBtn.textContent = '¡Número copiado!';
          setTimeout(function () { copyBtn.textContent = orig; }, 1800);
        });
      });
    }
    var numBtn = document.getElementById('davie-call-num');
    if (numBtn) {
      var fb = numBtn.querySelector('.davie-call__copy');
      numBtn.addEventListener('click', function () {
        copyText(numBtn.getAttribute('data-num') || '', function () {
          if (fb) { fb.textContent = '¡Copiado!'; setTimeout(function () { fb.textContent = ''; }, 1800); }
        });
      });
    }
  })();

  /* ---- Envío ---- */
  var submitted = false;

  function validNow() {
    if (form.checkValidity && !form.checkValidity()) { if (form.reportValidity) form.reportValidity(); return false; }
    return true;
  }

  // Botón type="button": el envío es 100% por JS. NUNCA hay submit nativo,
  // así Shopify no muestra su captcha /challenge ni recarga la página.
  var submitBtn = document.getElementById('davie-submit-btn');
  if (submitBtn) submitBtn.addEventListener('click', function () { if (validNow()) handleLead(); });
  // Fallback tecla Enter: preventDefault + misma lógica (tampoco envía nativo)
  form.addEventListener('submit', function (e) { e.preventDefault(); if (validNow()) handleLead(); });

  function handleLead() {
    if (submitted) return;
    submitted = true;

    // Teléfono internacional completo al campo que se guarda
    var phoneFull = document.getElementById('davie-phone-full');
    if (phoneFull) phoneFull.value = fullPhone();
    // Link clickeable de WhatsApp al lead (para el email a Andrew)
    var waLink = document.getElementById('davie-wa-link');
    if (waLink) waLink.value = 'https://wa.me/' + digits(phoneE164());

    var bodyEl = document.getElementById('davie-body');
    var qEl = document.getElementById('davie-quality');
    var qualified = isQualified();
    if (bodyEl) bodyEl.value = buildBody();
    if (qEl) qEl.value = qualified ? 'CALIFICADO' : 'NO CALIFICADO';

    // Envía el lead al Worker SIEMPRE (email a Andrew + Sheet). Pixel + Meta solo si califica.
    sendLead(qualified, uuid());

    // Guarda SIEMPRE el lead en Shopify (email a Andrew) — no se pierde ninguno
    var action = form.getAttribute('action') || '/contact';
    try {
      fetch(action, { method: 'POST', body: new FormData(form), keepalive: true, headers: { 'Accept': 'application/json' } }).catch(function () {});
    } catch (err) {}

    // Redirección según el canal elegido (la señal de Meta ya se disparó arriba, sin cambios)
    var method = contactMethod();
    if (method === 'Llamada') {
      showSuccess('davie-success-call');
    } else {
      setSuccessText(val('davie-redirect-title'), val('davie-redirect-text'));
      showSuccess('davie-success');
      var url = method === 'SMS' ? smsUrl() : whatsappUrl();
      setTimeout(function () { window.location.href = url; }, 700);
    }
  }
})();
